// extracted by mini-css-extract-plugin
module.exports =  {"chartBlock":"chartBlock__kT8oZ"};